<template>
  <div id="app">
      <UserBlocked v-if="isUserBlocked" />
      <router-view v-else />
  </div>
</template>

<script>
import { mapState } from "vuex";
import UserBlocked from "./components/UserBlocked.vue";

export default {
  name: "App",
  components: { UserBlocked },
  computed: {
    ...mapState("utils", ["user"]),
    isUserBlocked() {
      return Boolean(this.user) && this.user.user_type === "error";
    },
  },
};
</script>

<style lang="scss">
#app {

  .pc {
    margin-top: 0;

  }
}
    .preload {
      .preload-wrapper {
          opacity: 0.9;
          background-color: #fff;
          height: 100%;
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          position: absolute;
          z-index: 12;
          max-width: 800px;
      }
      .preload-dots{
          height: calc( 100vh - 61px);
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
          z-index: 12;
          //max-width: 800px;
      }
    }

.v-toast__text {
  color: white;
}
</style>
